import React from 'react'
import styles from './TableLine.module.scss'
import { TableLineProps } from './types'
import { Cell } from './Cell'

const TableLineComponent = (props: TableLineProps) => {
  const {
    cells, expanded, toggleExpand, paddingLevel
  } = props

  return (
    <div className={styles.tableLine}>
      {cells.map((cell, index) =>
        <Cell
          key={index}
          cell={cell}
          expanded={expanded}
          toggleExpand={toggleExpand}
          paddingLeft={index === 0 ? paddingLevel * 35 : 0}
        />
      )}
    </div>
  )
}

const TableLine = TableLineComponent
export { TableLine }
